import { useApi } from "../../../swr/useApi";
import { countriesService } from "../../api_client";
import type { CountryDto } from "../../../api";

export function useCountries() {
    return useApi<CountryDto[]>("countries", async () => {
        return await countriesService.getCountries();
    });
}


